<template>
  <el-dialog
    v-if="visible"
    :custom-class="$style.dialog"
    :title="title"
    :visible="true"
    @close="close"
  >
    <div :class="$style.content">
      <Item title="主机记录" required>
        <el-input
          v-model.trim="host"
          placeholder="请输入主机记录"
          @input="onHostChange"
        />
        <span :class="$style.desc">
          {{ domainName }}
        </span>
      </Item>

      <Item title="记录类型" required>
        <div :class="$style.select_type">
          <el-select v-model="type" placeholder="请选择" @change="onTypeChange">
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.type"
              :value="item.type"
            />
          </el-select>
          <span :class="$style.desc">{{ typeDesc }}</span>
        </div>
      </Item>

      <Item title="线路类型" required>
        <el-select v-model="lineId" placeholder="请选择">
          <el-option
            v-for="(item, index) in lineList"
            :key="index"
            :label="item.lineName"
            :value="item.lienId"
          />
        </el-select>
      </Item>

      <Item title="记录值" required>
        <el-input
          v-model.trim="value"
          placeholder="请输入记录值"
          @input="onValueChange"
        />
      </Item>

      <Item title="MX优先级" required>
        <el-input v-model.trim="mx" @input="onMxInput" @change="onMxChange" />
        <span :class="$style.desc"> MX优先级范围 1-20 </span>
      </Item>

      <Item title="ttl" required>
        <el-input
          v-model.trim="ttl"
          @input="onTtlInput"
          @change="onTtlChange"
        />
        <span :class="$style.desc"> ttl范围 600-604800 </span>
      </Item>

      <Item title="手机号码">
        <div :class="$style.input_phone">
          <el-input v-model.trim="userInfo.mobile" disabled />
          <CaptchaButton :class="$style.btn_captcha" />
          <span :class="$style.desc">
            {{ "若手机号已停用无法收到短信，请联系在线客服!" }}
          </span>
        </div>
      </Item>

      <Item title="短信验证码" required>
        <el-input v-model.trim="code" maxlength="6" />
      </Item>
    </div>

    <Row :class="$style.bottom_actions">
      <Button type="primary" @click="confirm">确认</Button>
      <Button type="primary2" @click="close">取消</Button>
    </Row>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";

import CaptchaButton from "@components/CaptchaButton.vue";

import { getResolutionLine } from "@server";

export default {
  name: "EditAnalysisPopup",
  components: { CaptchaButton },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mode: {
      // 0 - 添加 ， 1 - 修改
      type: Number,
      default: 0,
    },
    domainName: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      host: "", // 主机
      typeList: [],
      type: "",
      typeDesc: "",
      lineList: [],
      lineId: "0",
      value: "",
      mx: 1,
      ttl: 600,
      code: "",
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),

    title() {
      return `${this.mode ? "修改" : "添加"}域名解析`;
    },
  },
  watch: {
    item: {
      handler(val) {
        if (this.mode === 1 && Object.keys(val).length === 0) return;
        this.showData(val);
      },
      deep: true,
    },
  },
  methods: {
    showData(data) {
      this.host = data.host;
      this.type = data.recordType;
      this.lineId = data.lineId ? "" + data.lineId : "0";
      this.value = data.recordValue;
      this.mx = data.mx ? data.mx : 1;
      this.ttl = data.ttl ? data.ttl : 600;
    },

    async getResolutionLine() {
      const res = await getResolutionLine();
      const { code, data } = res;

      if (code === 200 && data) {
        this.lineList = data.lineList;
        this.lineList.length > 0 && (this.lineId = this.lineList[0].lienId);
        this.typeList = data.recordList;
      }
    },

    onTypeChange(type) {
      const item = this.typeList.find((i) => i.type === type);
      this.typeDesc = item.desc;
    },

    onHostChange(val) {
      this.host = val.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g, "");
    },

    onValueChange(val) {
      this.value = val.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g, "");
    },

    onMxInput(val) {
      let res = val.match(/\d{0,2}/g)[0];
      res > 20 && (res = 20);
      this.mx = res;
    },
    onMxChange(val) {
      !val && (this.mx = 1);
    },

    onTtlInput(val) {
      let res = val.match(/\d{0,6}/g)[0];
      res > 604800 && (res = 604800);
      this.ttl = res;
    },
    onTtlChange(val) {
      !val && (this.ttl = 600);
    },

    checkConfirm() {
      if (!this.host) {
        this.$message({ message: "请输入主机记录!", type: "warning" });
        return false;
      }
      if (!this.type) {
        this.$message({ message: "请输入记录类型!", type: "warning" });
        return false;
      }
      if (!this.value) {
        this.$message({ message: "请输入记录值!", type: "warning" });
        return false;
      }
      if (!this.code) {
        this.$message({ message: "请输入验证码!", type: "warning" });
        return false;
      }

      return true;
    },

    confirm() {
      if (!this.checkConfirm()) return;

      const params = {
        host: this.host,
        type: this.type,
        lineId: this.lineId,
        value: this.value,
        mx: this.mx,
        ttl: this.ttl,
        code: this.code,
      };

      this.$emit("confirm", params);

      this.close();
    },

    close() {
      this.host = "";
      this.type = "";
      this.lineId = "0";
      this.value = "";
      this.mx = 1;
      this.ttl = 600;
      this.code = "";
      this.$emit("close");
    },
  },
  created() {
    this.getResolutionLine();
  },
};
</script>

<style lang="scss" module scoped>
::v-deep .dialog {
  width: 520px;

  :global {
    .el-input {
      width: 180px;
      margin-right: rem(30);
    }

    .gl-item {
      margin-bottom: 40px;
    }

    .gl-button {
      margin: 0 !important;
    }
  }

  .content {
    max-height: 60vh;
    padding: rem(20) rem(40);
    overflow: overlay;
    @include scrollbar();

    .phone {
      width: 100%;
    }

    .captcha {
      width: 100px;
    }

    .btn_captcha {
      width: 118px;
      padding-left: 0;
      padding-right: 0;
    }
  }

  .desc {
    white-space: nowrap;
    font-size: rem(14);
    color: #333;
  }

  .select_type {
    position: relative;

    .desc {
      position: absolute;
      top: 50px;
      left: 0;
    }
  }

  .input_phone {
    position: relative;

    .desc {
      position: absolute;
      top: 50px;
      left: 0;
    }
  }

  .bottom_actions {
    padding-top: rem(20);
    margin-top: rem(10);
    justify-content: center;
    gap: 50px;
    border-top: $border-1;
  }
}
</style>
